import { createSelector } from 'reselect';
import { getIsWaitingForWork } from './getIsWaitingForWork';
import { getIsUnknownJob } from './getIsUnknownJob';

export const getIsWaitingForWorkOrUnknownJob = createSelector(
  [getIsWaitingForWork, getIsUnknownJob],
  (isWaitingForWork, isUnknownJob) => {
    return isWaitingForWork || isUnknownJob;
  }
);
